'use strict';

export default class Rating {
	constructor(params) {
		this.root = params.root;
	}

	init() {
		if (!this.root) return false;
		this.rateCount = parseFloat(this.root.dataset.rating);
		this._matchHTML();
		this._unlimitedMode();
	}

	_matchHTML() {
		this.unlimitedRating = this.root.querySelector('.rating__list--unlimited-mode');
	}

	_unlimitedMode() {
		if (!this.unlimitedRating || !this.rateCount) return false;

		let starWidth = parseInt(getComputedStyle(this.unlimitedRating.querySelector('.rating__icon')).backgroundSize),
			starContainerWidth = parseInt(getComputedStyle(this.unlimitedRating.querySelector('.rating__icon')).width),
			floorRate = Math.floor(this.rateCount),
			rest = (this.rateCount - floorRate),
			// offset = (parseInt(getComputedStyle(this.unlimitedRating.querySelector('.rating__icon')).width) - starWidth),
			width = 0, total = 0;

		width = floorRate * starContainerWidth;
		rest = starWidth * rest;
		total = width + rest;
		
		this.unlimitedRating.style.width = `${total}px`;
	}

}
